import { IRouter, Location } from '@cp/shared/router';

export class StaticRouter implements IRouter {
  readonly #location: Location;
  constructor(location: Location) {
    this.#location = location;
  }

  get location() {
    return this.#location;
  }

  navigate() {
    return Promise.resolve();
  }
}
